<script>
import { browser } from '$app/environment';
import { onMount, onDestroy } from 'svelte';
import logo from '$lib/images/logo.svg';
import { page } from '$app/stores';  
import { getHref } from '$lib/storyblok';
import { availableLanguageTags } from "$lib/../paraglide/runtime.js"

// Move the subscription code inside this component
let currentPage;
const unsubscribe = page.subscribe(value => {
  currentPage = value;
});

let parts = $page.url.pathname.split("/").filter(Boolean); 
let currentLanguage = parts[0];  
parts = parts.slice(1); // 
let newPath = parts.join("/"); 

let bgColor = "";

if(currentPage.data.story && currentPage.data.story.content.kleur) {
  bgColor = "background-" + currentPage.data.story.content.kleur;
}

export let algemeen;

let menuIsOpen = false;
let menuSticky = false;
let headerHeight;
let clientWidth;
let menuLength = algemeen.content.hoofdmenu.length;
let submenuIsOpen = Array(menuLength).fill(false);

function openSubmenu() {
		this.classList.toggle("open");
}

function handleScroll (event) {  
  if(window.scrollY > 100) {
      menuSticky = true;
  }else {
      menuSticky = false;
  }
}

function menuResize() {
  var menuplaceholder = document.getElementById("menu-placeholder");
  var fullMenu = document.getElementById("full-menu");
  var menubarHeight = fullMenu.offsetHeight;
  
  var placeholderHeight = menubarHeight;
  
  menuplaceholder.style.height = placeholderHeight + 'px';
}

onMount(async () => {  
  menuResize();
});

// Remember to unsubscribe when this component is destroyed
onDestroy(() => {
  unsubscribe();
});

console.log(availableLanguageTags)
</script>

<svelte:window on:scroll={handleScroll}/>
<div class="full-menu-holder {menuSticky?'sticky':''} {(menuIsOpen?'menu-open':'')}" id="full-menu" bind:clientWidth={clientWidth}>
  {#if algemeen.content.toon_top_menu}
    <div class="topmenu {bgColor}" id="topmenu">
      <div class="container">
        <div class="topmenu-holder">
          {#if algemeen.content.topmenu}
          <ul>
            {#each algemeen.content.topmenu as item}
            <li>
              {#if item.link.target == "_blank"}
              <a href={getHref(item.link)} target="_blank" >{item.naam}</a>
              {:else}
              <a href={getHref(item.link)} >{item.naam}</a>
              {/if}
            </li>
            {/each}
          </ul>
          {/if}
        </div>
        {#if algemeen.content.eMailadres || algemeen.content.telefoonnummer}
        <div class="contact-info-holder">
          <div class="contact-info custom">
            <div class="video-link-holder">
              {algemeen.content.topmenu_link_tekst}
              {#if algemeen.content.doorverwijzing_tekst && algemeen.content.doorverwijzing.cached_url }
                <a href={getHref(algemeen.content.doorverwijzing)} class="button">
                  {algemeen.content.doorverwijzing_tekst}
                </a>
              {/if}
            </div>
          </div>
          <!--{#if algemeen.content.telefoonnummer}
          <div class="contact-info">
            <div class="icon-holder">
              <svg width="16px" height="22px" viewBox="0 0 16 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Homepage---Ficare" transform="translate(-1260.000000, -14.000000)">
                          <g id="Group-11" transform="translate(1261.000000, 15.000000)">
                              <g id="smartphone-(1)" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.66666667">
                                  <g id="Group-10">
                                      <rect id="Rectangle" x="0" y="0" width="14" height="20" rx="1.66666667"></rect>
                                  </g>
                              </g>
                              <rect id="Rectangle" class="small-dot" fill="#222" x="6" y="15" width="2" height="2" rx="1"></rect>
                          </g>
                      </g>
                  </g>
              </svg>
            </div>
            <a href="tel:{algemeen.content.telefoonnummer}">{algemeen.content.telefoonnummer}</a>
          </div>
          {/if}-->
          <!--{#if algemeen.content.emailadres}
          <div class="contact-info">
            <div class="icon-holder">
              <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
                      <g id="Homepage---Ficare" transform="translate(-1415.000000, -18.000000)" stroke="#222" stroke-width="1.66666667">
                          <g id="mail-(1)" transform="translate(1416.000000, 19.000000)">
                              <path d="M1.66666667,0 L15,0 C15.9166667,0 16.6666667,0.75 16.6666667,1.66666667 L16.6666667,11.6666667 C16.6666667,12.5833333 15.9166667,13.3333333 15,13.3333333 L1.66666667,13.3333333 C0.75,13.3333333 0,12.5833333 0,11.6666667 L0,1.66666667 C0,0.75 0.75,0 1.66666667,0 Z" id="Path" stroke-linecap="round"></path>
                              <polyline id="Path" points="16.6666667 1.66666667 8.33333333 7.5 0 1.66666667"></polyline>
                          </g>
                      </g>
                  </g>
              </svg>
            </div>
            <a href="mailto:{algemeen.content.emailadres}">{algemeen.content.emailadres}</a>
          </div>
          {/if}-->
          <div class="language-selector">
            <div class="current-lang">{currentLanguage}</div>
            <div class="available-languages-holder">
              <div class="available-languages">
                  {#each availableLanguageTags as language}
                      {#if language != currentLanguage}
                        <a href="/{language}" on:click={() => currentLanguage = language}>{language}</a>
                      {/if}
                  {/each}
              </div>
            </div> 
          </div>
        </div>
        {/if}

        
      </div>
    </div>
  {/if}

  <div class="menu-bar">
    <div class="container">
      <div class="menu-inner">
        <div class="logo-holder">
          <a data-sveltekit-preload-data="tap" href={`/${currentLanguage}`}>
            <img src={logo} alt="" quality="100" />
          </a>
        </div>

        <div class="menu-right">
          <ul class="menu">
            {#each algemeen.content.hoofdmenu as item, index }
              <li class={item.submenu.length?'has-sub':''} role="presentation">
                {#if item.link.target == "_blank"}
                  <a href={getHref(item.link)} target="_blank" on:click={()=>{ menuIsOpen = false }}>{item.naam}</a>
                {:else}
                  <a href={getHref(item.link)} on:click={()=>{ menuIsOpen = false }}>{item.naam}</a>
                {/if}
                {#if item.submenu.length}
                  <span class="menu-arrow {(submenuIsOpen[index] && menuIsOpen?'rotate':'')}" on:click={()=>{ submenuIsOpen[index] = !submenuIsOpen[index] }}>
                    <svg width="11px" height="7px" viewBox="0 0 11 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Onlime---Templates-v2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="1-1-Onlime---Hero" transform="translate(-974, -101)" stroke="#F0F0E6" stroke-width="1.5">
                                <g id="Group-3" transform="translate(979, 104) rotate(-270) translate(-979, -104)translate(971, 96)">
                                    <g id="Group" transform="translate(0, -0)">
                                        <polyline id="Path" points="6.4 3.2 10.9 7.7 6.4 12.2"></polyline>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </span>

                  <div class="submenu-holder {(submenuIsOpen[index] && menuIsOpen?'open':'')}">
                    <ul class="submenu">
                      {#each item.submenu as subitem}
                      <li>
                        {#if subitem.link.target == "_blank"}
                        <a href={getHref(subitem.link)} target="_blank" on:click={()=>{ menuIsOpen = false }}>{subitem.naam}</a>
                        {:else}
                        <a href={getHref(subitem.link)} on:click={()=>{ menuIsOpen = false }}>{subitem.naam}</a>
                        {/if}
                      </li>
                      {/each}
                    </ul>
                  </div>
                {/if}
              </li>
            {/each}

            <li class="mobile-language-selector" on:click={()=>{ menuIsOpen = false }}>
                {#each availableLanguageTags as language}
                    <a href="/{language}" on:click={() => currentLanguage = language} class={currentLanguage == language?'active':''}>{language}</a>
                {/each}
            </li>
          </ul>

          <a class="search {bgColor}" href="/{currentLanguage}/search"></a>

          <div class="mobile-toggle {bgColor}" on:click={()=>{ menuIsOpen = !menuIsOpen }}>
            <span class="line top"></span>
            <span class="line bottom"></span>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
<div id="menu-placeholder"></div>

<style lang="postcss">

  /* ============= delete this after other languages are active =============*/


  /* ================= end delete =============== */ 

  .full-menu-holder {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
  }

  .topmenu {
    background-color: var(--topmenu-background);
    padding: 10px;
    text-align: right;
    font-size: 16px;
    line-height: 28px;

    .contact-info-holder {
      display: flex;
      justify-content: end;

      .contact-info {
        display: flex;

        &:not(:last-child) {
          margin-right: 20px;
        }

        &.custom {
          margin-right: 0;
        }

        a {
          color: var(--white);
        }

        .icon-holder {
          display: flex;;
          align-items: center;
          margin-right: 10px;
          svg g {
            stroke: var(--topmenu-color);

            .small-dot {
              fill: var(--topmenu-color);
            }
          }
        }
      }
    }
  }

  .language-selector {
    display: inline-block;
    margin-left: 10px;
    padding-left: 15px;
    padding-right: 20px;
    position: relative;
    transform: translateY(3px);
    text-transform: uppercase;
    cursor: pointer;
    color: #fff;

    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 6px;
      //background-image: url('$lib/images/arrow-small.svg');
      background-image: url('$lib/images/arrow-small-white.svg');
      background-repeat: no-repeat;
      background-position: center center;
      width: 16px;
      height: 16px;
      transition: all 300ms;
    }

    &:hover::after {
      transform: rotate(180deg);
    }
  }

  .menu .mobile-language-selector {
    text-transform: uppercase;
    margin-top: 40px;
    display: none;
  } 

  .menu .mobile-language-selector a {
    display: inline-block;
    padding: 0 10px 0 10px;
    border-left: 1px solid var(--black);
    font-size: 16px;
    line-height: 20px;

    &.active {
      color: var(--blue);
    }  

    &:first-child {
      padding-left: 0;
      border: none;
    }
  }

  .available-languages-holder {
    position: absolute;
    left: 0px;
    top: calc(100% - 3px);
    padding-top: 10px;
    visibility: hidden;
    opacity: 0;
    transition: all 300ms;
  }

  .language-selector:hover .available-languages-holder {
    visibility: visible;
    opacity: 1;
  }

  .available-languages {
    background-color: var(--menu-submenu-background-color);
    padding: 10px 15px 7px;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);
  }

  .available-languages a {
    display: block;
    color: var(--blue);

    &:hover {
      color: var(--black);
    }
  }
  
  .menu-bar {
    padding: 15px 0;
    background-color: var(--menu-background);
  }

  .menu-inner {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  .menu > {
    li {
      display: inline-block;
      
      a {
        transition: all .4s;

        &:hover {
          color: var(--menu-hover-color);
        }
      }

      &:not(:last-child) {
        margin-right: 30px;  
      }
      
      .menu-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        transition: all .4s;

        svg g {
          stroke: var(--body-color);
        }
      }
    }
  }

  .menu .has-sub {
    position: relative;
    padding-right: 20px;

    .submenu-holder {
      position: absolute;
      top: 100%;
      left: -30px;
      opacity: 0;
      visibility: hidden;
      transition: all .4s;
      min-width: 260px;
      box-sizing: border-box;
      padding-top: 20px;

      .submenu {
        padding: 30px;
        background-color: var(--menu-submenu-background-color);
        color: var(--menu-submenu-color);

        li {
          &:not(:last-child) {
            margin-bottom: 15px;  
          }
        } 

        a {
          transition: all .4s;
          line-height: 24px;
          display: block;

          &:hover {
            color: var(--menu-submenu-hover-color);
          }
        }
      }
    }

    &:hover {

      .menu-arrow {
        transform: translateY(-50%) rotate(180deg);
      }

      .submenu-holder {
        opacity: 1;
        visibility: visible;    
      }
    }
  }

  .menu-right {
    display: flex;
    align-items: center;
  }

  .mobile-toggle {
    width: 45px;
    height: 45px;
    display: none;
    position: relative;
    background-color: var(--mobile-toggle-background);
    margin-left: 30px;
    cursor: pointer;

    .line {
      position: absolute;
      width: 27px;
      height: 2px;
      background-color: var(--mobile-toggle-line-background);
      left: 50%;
      transform: translateX(-50%);

      &.top {
        top: 14px;
      }

      &.bottom {
        bottom: 14px;
      }
    }

  }

  .search {
    height: 36px;
    width: 36px;
    background-color: var(--blue);
    transition: all 300ms;
    background-image: url('$lib/images/icon-search.svg');
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      background-color: var(--dark-blue) !important;
    }
  }

  .video-link-holder {
    color: var(--white);

    .button {
      padding: 6px 15px;
      line-height: 22px;
      margin-left: 10px;
      color: var(--dark-blue) !important;

      &:hover {
        color: var(--dark-blue);
        background-color: var(--white);
        border-color: var(--white);
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .menu-bar {
      padding: 20px 0;
    }

    .mobile-toggle {
      display: block;
    }

    .menu-inner .menu {
      position: absolute;
      top: 100%;
      width: 100%;
      height: calc(100vh - 100%);
      left: -100%;
      background-color: var(--menu-background);
      padding: 20px 40px 40px 40px;
      opacity: 0;
      visibility: hidden;
      transition: all .4s;
      box-sizing: border-box;

      > li {
        display: block;
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 10px;
      }

      .has-sub {
        .submenu-holder {
          position: relative;    
          padding: 0;
          left: 20px;
          max-height: 0;
          overflow: hidden;
          opacity: 0;

          .submenu {
            padding: 0;
            background-color: transparent;
            color: var(--body-color);

            li {
              font-size: 20px;
            }
          }
        }

        .submenu-holder.open {
          opacity: 1;
          visibility: visible;
          max-height: 400px;
          margin: 15px 0;
        }
      }
    }

    .menu >li .menu-arrow {
      top: 13px;
      transform: translateX(9px);
      right: unset;

      svg { 
        width: 15px;
        height: 9px;
      }

      &.rotate {
        transform: translateX(9px) rotate(180deg) !important;
      }
    }

    .menu .has-sub:hover .menu-arrow {
      top: 13px;
      transform: translateX(9px);
    }

    .menu-open {
      .menu-inner .menu {
        opacity: 1;
        visibility: visible;
        left: 0;
      }
    }

    .language-selector {
      display: none;
    }

    .menu .mobile-language-selector {
      display: block;
    } 

    .search {
      height: 45px;
      width: 45px;
    }

    .mobile-toggle {
      margin-left: 10px;
    }
  }

  @media screen and (max-width: 767px) {
    .topmenu {
      display: none;
    }

    .menu-inner .menu {
      padding: 20px;
    }

    .menu-inner .logo-holder {
       max-width: 160px;
    }
  }
</style>